module.exports = __webpack_public_path__ + "img/olimar-min.389befee.png";